import { extend, override } from "flarum/common/extend";
import avatar from "flarum/common/helpers/avatar";
import username from "flarum/common/helpers/username";
import Link from "flarum/common/components/Link";
import UserPage from "flarum/components/UserPage";

export default function () {
  extend(UserPage.prototype, "view", function (vnode) {
    const title = "Самые активные за сутки";
    const { lastDayActivity } = app.forum.data.attributes;
    if (!lastDayActivity) return;

    const topLastDayUsers = Object.entries(lastDayActivity)
      .map((e) => e[1])
      .slice(0, 11);

    const notLoadedUsers = topLastDayUsers
      .filter(({ user_id }) => {
        const user = app.store.getById('users', user_id);
        return !user;
      });
    const hasNotLoadedUsers = notLoadedUsers.length > 0;

    if (hasNotLoadedUsers) {
      Promise.all(
        notLoadedUsers.map(({ user_id }) => {
          this.loading = true;
          return app.store.find("users", user_id)
        })
      ).then((r) => {
        r.map(({ data }) => app.store.pushObject(data));
        this.loading = false;
         // m.redraw();
      });
    }

    const childElems = (
      <ul>
        <li className="topUsersActivityCard-title">
          <div className="topQuestionsTitle">
            {title}
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          </div>
        </li>
        {topLastDayUsers.map(({ user_id, answers, questions }) => {
          const user = app.store.getById("users", user_id);
          // console.log(user);
          if (!user) return;
          return (
            <li className="topUsersActivityCard">
              <div className="topUsersAwa">
                {avatar(user)}
                <div>
                  <Link href={app.route.user(user)}>{username(user)}</Link>
                  <span className="userActivityAnswers">
                    {"Ответов: "}
                    {!!answers ? answers : "0"}
                  </span>
                  {/*<span className="userActivityQuestions">
                    {"Вопросов: "}
                    {!!questions ? questions : "0"}
                  </span>*/}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    );

    if(!document.querySelector('nav.AdvDiscusUserProfileWidjet')) {
      if(vnode.children[1]) {
        // console.log(vnode.children[1].children);
        vnode.children[1].children.push(m("nav.AdvDiscusUserProfileWidjet", childElems));
      }
    }
  });
}
